import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation resources
const resources = {
  en: {
    translation: {
      header: {
        about: "About Me",
        contact: "Contact Me",
        logoAlt: "Ana Gabriela"
      },
      home: {
        welcome: "Welcome to Ana Gabriela",
        subtitle: "This is the home page of your application.",
        testSection: "Test Section",
        testText: "If you can see this styled section, CSS is working!"
      },
      hero: {
        bookSession: "Book Your Session",
          micropigmentation: "Micropigmentation",
          browEyelashes: "Brows & Eyelashes"
      },
      about: {
        theArtist: "The Artist",
        name: "Ana Gabriela",
        tagline: "Leader in the World of Micropigmentation.",
        description: "For over 8 years, I have dedicated my career to elevating the art and science of micropigmentation. As International Representative of Magcolor, CEO of Art PMU Academy, and organizer of MagExperience Venezuela, my mission is to train excellent professionals and create trends.\n\nDemonstrating with solid foundations that Micropigmentation is not only Art, it is also a profitable business, I have established myself as an international reference in the sector thanks to my role that goes beyond the studio: As the only Grand Master of Magcolor, Venezuela and Europe, I have led the training of more than 1,000 micropigmentation artists, providing them not only with technique but also with the tools for a prosperous business.\n\nThis triple perspective — technical, educational, and business — backed by more than 2,000 successful procedures, allows me to offer a comprehensive and leadership vision to any professional who wishes to make a difference in this art.",
        bridesSpecialist: "Bridal Specialist",
        redCarpet: "Red Carpet"
      },
      portfolio: {
          portfolioInMotion: "Portfolio in Motion",
          seeTransformation: "See the Transformation"
      },
      contact: {
        readyToShine: "Ready to shine?",
        limitedSlots: "Limited slots available for wedding and editorial sessions. Connect with me directly to discuss your vision.",
        whatsapp: "Message me on WhatsApp",
        joinCommunity: "Join the Community"
      },
      footer: {
        copyright: "© 2024 Ana Gabriela Artistry • All Rights Reserved"
      }
    }
  },
  es: {
    translation: {
      header: {
        about: "Acerca de mí",
        contact: "Contactame",
        logoAlt: "Ana Gabriela"
      },
      home: {
        welcome: "Bienvenida a Ana Gabriela",
        subtitle: "Esta es la página principal de tu aplicación.",
        testSection: "Sección de Prueba",
        testText: "¡Si puedes ver esta sección estilizada, CSS está funcionando!"
      },
      hero: {
        bookSession: "Agenda tu sesión",
      micropigmentation: "Micropigmentación",
          browEyelashes: "Cejas & Pestañas"
      },
      about: {
        theArtist: "La Artista",
        name: "Ana Gabriela",
        tagline: "Líder en el Mundo de la Micropigmentación.",
        description: "Por más de 8 años, he dedicado mi carrera a elevar el arte y la ciencia de la micropigmentación. Como Representante Internacional de Magcolor, CEO de la Academia Art PMU y organizadora del MagExperience Venezuela, mi misión es formar profesionales de excelencia y crear tendencias.\n\nDemostrando con bases sólidas que la Micropigmentación no es solo Arte, es también un negocio rentable, me he consolidado como una referente internacional en el sector gracias a Mi rol que va más allá del estudio: Única Grand Master de Magcolor, Venezuela y Europa he liderado la formación de más de 1,000 micropigmentadoras, brindándoles no solo técnica, sino las herramientas para un negocio próspero.\n\nEsta triple perspectiva —técnica, formativa y de negocio—, respaldada por más de 2,000 procedimientos exitosos, me permite ofrecer una visión integral y de liderazgo a todo profesional que desee marcar la diferencia en este arte.",
        bridesSpecialist: "Especialista en Novias",
        redCarpet: "Alfombra roja"
      },
      portfolio: {
        portfolioInMotion: "Portafolio en Movimiento",
        seeTransformation: "Mira la Transformación"
      },
      contact: {
        readyToShine: "¿Lista para brillar?",
        limitedSlots: "Cupos limitados para las sesiones de boda y editorial. Conéctate conmigo directamente para discutir tu visión.",
        whatsapp: "Escríbeme a WhatsApp",
        joinCommunity: "Únete a la comunidad"
      },
      footer: {
        copyright: "© 2024 Ana Gabriela Artistry • Todos los Derechos Reservados"
      }
    }
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'es', // Default language
    fallbackLng: 'en',
    
    interpolation: {
      escapeValue: false, // React already escapes
    },
    
    react: {
      useSuspense: false,
    }
  });

export default i18n;
